import React from "react";
import Logo from "../logo/logo";
import Navbar from "../navbar/navbar";
import styles from "./header.module.scss";

const Header: React.FC = () => {
  return (
    <header className={styles.header}>
      <Logo className={styles.logo} />
      <Navbar />
    </header>
  );
};

export default Header;
